import React from 'react';
import BottomSheetBase from '../../../comm/BottomSheetBase';
import style from './FoodRecognitionFailSheet.module.css';

/**
 * 음식 인식 실패 → 대체 입력 방법 선택
 *
 * @param {boolean}    open
 * @param {() => void} onDismiss
 * @param {string}    [title]          실패 원인별 제목. 없으면 기본 문구
 * @param {string}    [desc]           실패 원인별 설명. 줄바꿈은 \n
 * @param {() => void} onRetakePhoto    다시 촬영하기
 * @param {() => void} onScanBarcode    바코드로 스캔
 * @param {() => void} onSelectGallery  갤러리에서 선택
 * @param {() => void} onSearchFood     음식 검색
 * @param {() => void} onManualEntry    직접 음식 등록
 */
const DEFAULT_TITLE = '음식 인식 실패';
const DEFAULT_DESC = '음식을 발견하지 못했어요.\n식사를 다시 기록해 주세요.';

const FoodRecognitionFailSheet = ({
    open,
    onDismiss,
    title,
    desc,
    onRetakePhoto,
    // onScanBarcode,
    onSelectGallery,
    onSearchFood,
    onManualEntry,
}) => {
    const actions = [
        { key: 'retake',   icon: 'camera',   label: '다시 촬영하기',   onClick: onRetakePhoto },
        // { key: 'barcode',  icon: 'barcode',  label: '바코드로 스캔',   onClick: onScanBarcode },
        { key: 'gallery',  icon: 'gallery',  label: '갤러리에서 선택', onClick: onSelectGallery },
        { key: 'search',   icon: 'search',   label: '음식 검색',       onClick: onSearchFood },
        { key: 'manual' ,   icon: 'edit',     label: '직접 음식 등록',  onClick: onManualEntry },
    ];

    return (
        <BottomSheetBase open={open} onDismiss={onDismiss}>
            <h3 className={style.title}>{title || DEFAULT_TITLE}</h3>
            <div className={style.iconWrap}></div>
            <p className={style.desc}>
                {(desc || DEFAULT_DESC).split('\n').map((line, i) => (
                    <React.Fragment key={i}>
                        {i > 0 && <br />}
                        {line}
                    </React.Fragment>
                ))}
            </p>

            <ul className={style.actionList}>
                {actions.map((a) => (
                    <li key={a.key}>
                        <button
                            type="button"
                            className={style.actionBtn}
                            onClick={() => {
                                a.onClick?.();
                                onDismiss?.();
                            }}
                        >
                            <span
                                className={`${style.actionIcon} ${style[`icon_${a.icon}`]}`}
                                aria-hidden="true"
                            />
                            <span className={style.actionLabel}>{a.label}</span>
                            <span className={style.actionArrow} aria-hidden="true"></span>
                        </button>
                    </li>
                ))}
            </ul>
        </BottomSheetBase>
    );
};

export default FoodRecognitionFailSheet;